import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    "name": "scarstage",
    standalone: true
})
export class ScarStageIndicatorPipe implements PipeTransform {
    transform (value: string): string {
        switch (value) {
            case ("Start"):
                return "fas fa-lg fa-thermometer-empty";
            case ("Frame"):
                return "fas fa-lg fa-thermometer-half";
            case ("Second"):
                return "fas fa-lg fa-thermometer-three-quarters";
            case ("Final"):
                return "fas fa-lg fa-thermometer-full";
            default:
                return null;
        }
    }
}
